import React, { Component, Fragment } from "react";
import { Link } from 'react-router-dom';
import "./Movies.scss";
import dataJSON from "../../static/api/data.json";
import queryString from "query-string";
import Slider from "../Helpers/Slider/Slider";
import { GA_Push } from "../Services/GoogleAnalytics";
import { mobile } from "../Services/Agent";
import { scrollDown, scrollToElement } from "../Services/scrollAnimation";
import Welcome from "../Welcome/Welcome";



const InnerItem = props => {
    let startPos = () => {
        try {
            const hash = queryString.parse(window.location.hash.toLocaleLowerCase());
            const isMonthActive = [
                ["january", 0],
                ["february", 1],
                ["march", 2],
                ["april", 3],
                ["may", 4],
                ["june", 5],
                ["july", 6],
                ["august", 7],
                ["september", 8],
                ["october", 9],
                ["november", 10],
                ["december", 11]
            ].filter(m => m[0] == Object.keys(hash)[0])[0][1];
            if (dataJSON[isMonthActive].length != 0 && props.index == isMonthActive) {
                return true;
            }
        } catch (e) {
            return false;
        }
    }
    return (
        <div className={`item image-${props.index + 1} ${startPos() ? "active" : ""}`}>
            <Link to={`/article/${props.articleVignetteId}`} target="_blank" onClick={() => { GA_Push("Month_Clicked", props.name) }}>
                <div className="item-pad">
                    <div className="month">{props.name}</div>
                    <div className="link">לסיקור המלא >></div>
                </div>
                <div className="fade"></div>
            </Link>
        </div>
    )
}
export default class Movies extends Component {
    constructor() {
        super();
        this.setOwlRef = this.setOwlRef.bind(this);
        this.state = {
            OwlRef: null
        }
    }
    componentDidMount() {
        this.slider.addEventListener("mouseover", () => {
            if (this.slider.querySelector(".item.active") != null) {
                Array.from(this.slider.querySelectorAll(".item.active")).forEach(obj => obj.classList.remove("active"));
            }
        })
        // if (window.location.hash != "") {
        //     if (mobile()) {
        //         scrollDown(".mob-con .item.active", 20);
        //     } else {
        //         scrollDown(".section-movies", 0);
        //     }
        // }
        if (document.querySelector('.App'))
            document.querySelector('.App').classList = "App landingPage";
    }
    renderMovies() {
        return dataJSON.map((item, index) => <InnerItem key={index} index={index} {...item} />)
    }
    setOwlRef(ref) {
        this.setState({
            OwlRef: ref
        })
    }
    render() {
        return (
            <Fragment>
                <Welcome />
                <section className="section section-movies">
                    <div className="padding">
                        <div className="container">
                            <div className="line"></div>
                            <div className="slider movies" ref={slider => this.slider = slider}>
                                <div className="glow top"></div>
                                <Slider setOwlRef={this.setOwlRef}>
                                    {this.renderMovies()}
                                </Slider>
                                <div className="mob-con" ref={mobCon => this.mobCon = mobCon}>
                                    {this.renderMovies()}
                                </div>
                                <div onClick={() => {
                                    this.state.OwlRef != null ? this.state.OwlRef.prev(600) : null
                                }} className="arrow right"></div>
                                <div onClick={() => {
                                    this.state.OwlRef != null ? this.state.OwlRef.next(600) : null
                                }} className="arrow left"></div>
                                <div className="glow bottom"></div>
                            </div>
                            <div className="line"></div>
                        </div>
                    </div>
                </section>
            </Fragment>

        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Movies/Movies.jsx